module.exports = __webpack_public_path__ + "img/philosophy-of-psychology--causality-and-psychological-subject--epistemic-studies-cover.a1f1f402.jpg";